<div class="hamburguer__menu">
  <input
    type="checkbox"
    id="checkbox-menu"
    (click)="alterarStatusHamburguer()"
  />
  <label for="checkbox-menu">
    <span></span>
    <span></span>
    <span></span>
  </label>
</div>
